import { useQuery } from '@tanstack/react-query';
import { positionProfilesService } from '../services/positionProfilesService';

export const POSITION_PROFILES_WITH_TECH_QUERY_KEY = ['position-profiles', 'with-technologies'] as const;

export const usePositionProfilesWithTechnologies = () =>
    useQuery({
        queryKey: POSITION_PROFILES_WITH_TECH_QUERY_KEY,
        queryFn: positionProfilesService.getWithTechnologies,
        staleTime: 1000 * 60 * 15, // 15 minutes
        gcTime: 1000 * 60 * 30,    // 30 minutes
    });
